import React from 'react';
import Email from '../Email';
import tools from '../../lib/tools';

export default function AguardandoAnalise({ resp = {}, notify = false, print = false, viewHeader = false }) {

    const openURL = (error = false) => {
        return tools.openURL(`${resp.url}`);
    }

    return (
        <Email emailClass={`${print ? 'print-email' : 'email'}`}>
            <br />
            <br />
            <div className="w-100">
                <p className="text-center mt-30 mb-30 fb-18">PROCESSO AGUARDANDO ANÁLISE / AJUSTES</p>
            </div>
            <p>Olá, Dr.(a) <b>{resp.desempatador_responsavel_nome}</b>. Espero que esteja bem.</p>
            <p> Gostaria de informar que o processo de ID {resp.protocolo} está disponível na plataforma para sua análise e/ou ajuste.</p>
            <br />
            <button className="btn btn-primary f700-16 w-100" onClick={openURL}>Visualizar processo</button>
            <br />
            <br />
            <p>Aguardamos sua conclusão para finalizar o processo.</p>
            <p>Estamos à disposição para qualquer dúvidas.</p>
            <br />
            <div className="w-100 text-justify bold pb-50">
                <p>Obrigada!<br />
                    Equipe säästö.</p>
            </div>
        </Email>
    );
}
